<template>
    <v-row>
      <v-dialog v-model="showDialog" scrollable max-width="800px">
        <v-skeleton-loader
        v-if="loading"
          type="article, actions"
        ></v-skeleton-loader>
        <v-card v-if="!loading">
          <v-card-title style="padding: 10px 0 0 10px; height: 20px;">
            <v-col cols="12">
                          <span v-if="!isClosed" style="font-size: 20px;">
                              {{ $t('wkt.admin.complaint.new-message-window.title') }}
                          </span>
                          <span v-if="isClosed && status === 3" style="font-size: 20px;">
                              {{ $t('wkt.admin.complaint.new-message-window.complaint-dismissed') }}
                          </span>
                          <span v-if="isClosed && status === 4" style="font-size: 20px;">
                              {{ $t('wkt.admin.complaint.new-message-window.complaint-closed') }}
                          </span>
            </v-col>
          </v-card-title>
          <v-card-text style="padding-bottom: 0;">
            <v-container>
                          <v-form ref="form">
                              <v-row style="margin-top: 20px;">
  
                                <v-col v-if="isClosed" cols="12" class="pb-0">  
                                    <p v-if="status === 3">{{ $t('wkt.admin.complaint.new-message-window.text-dismissed') }}</p> 
                                    <p v-if="status === 4">{{ $t('wkt.admin.complaint.new-message-window.text-closed') }}</p>
                                </v-col>
                                  
                                  <v-col cols="12">  
                                    <tiptap-vuetify 
                                    v-model="data.message" 
                                    :placeholder="$t('wkt.admin.complaint.new-message-window.write_your_message_here')"
                                    :extensions="extensions" :card-props="{ flat: true }" 
                                    style="height: 300px; overflow-y: auto; border: 1px solid #DDDDDD; border-radius: 6px;"/>
                                  </v-col>
  
                                  <v-col cols="12">       
                                    <v-file-input
                                       v-if="!isClosed"
                                       multiple chips truncate-length="45"
                                       :label="$t('wkt.admin.complaint.new-message-window.attached_files')"
                                       v-model="files"
                                    ></v-file-input>
                              </v-col>
                              </v-row>
                          </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn v-if="data.id" color="#ff0000" @click="confirmDelete()">
                          <v-icon left color="#ffffff">delete</v-icon>
                          <span style="color: #ffffff;">{{ $t('wkt.admin.common.dialog-buttons.delete').toUpperCase() }}</span>
                      </v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="!canSendMessage" color="#185EA9" text @click="onSave()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
            <v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>	
  </template>
  
<script>
import BaseModule from '../../../common/BaseModule.js'
import api from '../../../../api/worktime'
import { TiptapVuetify, Bold, Italic, Strike, Underline, Code, BulletList, OrderedList, ListItem, Link, Blockquote, History } from 'tiptap-vuetify'

export default {
   name: 'ComplaintMessageDialog',
   mixins: [BaseModule],
   props: ['isAdmin'],
   components: {
      TiptapVuetify
   },
   data() {
      return {
         showDialog: false,
         loading: true,
         files: null,
         status: null,
         callback: null,
         data: {},
         extensions: [
               History,
               Blockquote,
               Link,
               Underline,
               Strike,
               Italic,
               ListItem,
               BulletList,
               OrderedList,
               Bold,
               Code
            ],
      }
   },
   computed: {
      canSendMessage() {
         return this.data.message && this.data.message.length > 20;
      },
      isClosed() {
         return this.status && this.status >= 3;
      },
   },
   methods: {
      // eslint-disable-next-line no-unused-vars
      open(complaintId, status, callback) {
         this.status = status;
         this.callback = callback;
         this.showDialog = true;
         this.loading=false;
         this.files = null;

         if (this.$refs.form) {
            this.$refs.form.resetValidation();
         }

         this.data = { 
            complaintId: complaintId,
            isPublic: true,
            message: null
         };
      },
      onSave() {
         if (!this.$refs.form.validate() || !this.data.message) {
            return;
         }

         this.loading = true;
         let formData = new FormData();

         // files
         if (this.files) { 
            for (let file of this.files) {
               formData.append("file", file, file.name);
            }
         }
         
         if (this.isClosed) {
            const message = this.data.message;

            if (this.status === 3) {
               this.data.message = `<h3>${this.$t('wkt.admin.complaint.new-message-window.complaint-dismissed')}</h3><br>`;
            }
            if (this.status === 4) {
               this.data.message = `<h3>${this.$t('wkt.admin.complaint.new-message-window.complaint-closed')}</h3><br>`;
            }
               
            this.data.message += `<p>${this.$t('wkt.admin.complaint.new-message-window.reason')}</p>${message}`;
         }

         const actualMessage = this.data.message.replace('<a href=','<a target="_blank" href=');

         // additional data
         formData.append("complaintId", this.data.complaintId);
         formData.append("isPublic", this.data.isPublic);
         formData.append("message", actualMessage);   
         formData.append("sendEmail", true);        

         api.createComplaintMessage(formData, 
            res => {
               this.loading = false;
               if (res.id) {
                  if (this.isClosed) {
                     if (this.callback) {
                        this.callback();
                     }
                  } 
                  else {
                     this.$emit('refresh');
                  }
                  this.showDialog = false;
               } else {
                  this.$emit('show-alert', { text: res.message, color: 'error', timeout: 3000 });
               }
            },
            error => {
               this.$log.error(error);
               this.loading = false;
               this.$emit('show-alert', { text: error, color: 'error', timeout: 3000 });
            });
      }
   },
}
</script>